import getPropertyDefinition from './getPropertyDefinition';
/**
 * Returns the label of the property.
 */

const getPropertyLabel = (properties, propertyName) => {
  return getPropertyDefinition(properties, propertyName).label;
};
export default getPropertyLabel;